'use client'

import { Button } from '@/core/ui/atoms/button'
import { useTranslations } from 'next-intl'

export const Error500Content = () => {
  const t = useTranslations()

  return (
    <main className='mb-6 flex flex-col gap-8'>
      <Button variant='contained' onClick={() => location.reload()}>
        {t('actions.reload')}
      </Button>
    </main>
  )
}
